var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14C7.23333 14 7 13.9 6.8 13.7C6.6 13.5 6.5 13.2667 6.5 13V12C6.5 11.9417 6.50625 11.8792 6.51875 11.8125C6.53125 11.7458 6.55 11.6833 6.575 11.625L8.075 8.1C8.15 7.93333 8.275 7.79167 8.45 7.675C8.625 7.55833 8.80833 7.5 9 7.5H13C13.275 7.5 13.5104 7.59792 13.7063 7.79375C13.9021 7.98958 14 8.225 14 8.5V13.5875C14 13.7208 13.9729 13.8479 13.9188 13.9688C13.8646 14.0896 13.7917 14.1958 13.7 14.2875L10.9875 16.9875C10.8625 17.1042 10.7146 17.175 10.5438 17.2C10.3729 17.225 10.2083 17.1958 10.05 17.1125C9.89167 17.0292 9.77708 16.9125 9.70625 16.7625C9.63542 16.6125 9.62083 16.4583 9.6625 16.3L10.225 14H7.5ZM16 7.5C16.275 7.5 16.5104 7.59792 16.7063 7.79375C16.9021 7.98958 17 8.225 17 8.5V13C17 13.275 16.9021 13.5104 16.7063 13.7063C16.5104 13.9021 16.275 14 16 14C15.725 14 15.4896 13.9021 15.2937 13.7063C15.0979 13.5104 15 13.275 15 13V8.5C15 8.225 15.0979 7.98958 15.2937 7.79375C15.4896 7.59792 15.725 7.5 16 7.5Z",
    fill: "#CB7CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#F3E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb_down.2508b53fb980e4bf1cf6b90713de5ffc.svg";
export { ForwardRef as ReactComponent };